export default __webpack_public_path__ + "static/media/notes_img.76cbfb3e.png";